// src/services/api/movement.js
// Goto, caravan, and movement-related functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

const fetchGotoHelper = async (token, pointId, endpoint) => {
    const url = `${API_URL}${endpoint}`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { pointId },
    });
    if (!response.ok) {
        let errorResult = `${response.status}`;  // Default to status code
        try {
            const data = await response.json();
            console.log('[fetchGotoHelper] Error response data:', data);
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {
            console.error('[fetchGotoHelper] Failed to parse error response:', e);
        }
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

export const fetchGoto = async (token, pointId) => {
    return fetchGotoHelper(token, pointId, 'v2/goto');
};

export const fetchGotoCaravan = async (token, pointId) => {
    return fetchGotoHelper(token, pointId, 'v2/goto/caravan');
};
